import {EditIcon} from "@chakra-ui/icons";
import {
  Button, Grid, GridItem,
  IconButton, Input,
  Radio,
  RadioGroup,
  Stack,
  Td,
  Textarea,
  Tr,
  useToast,
} from "@chakra-ui/react";
import React, {useEffect,useState} from "react";
import {useMutation, useQueryClient} from "react-query";

import {updateUserRevisionCode} from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {Authority, UserStatus} from "../../shared/model/Constants";
import {UserDto} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {getUserTag} from "../../shared/Utils";

type JudgeSummaryItemProps = {
  user: UserDto;
};

const JudgeSummaryItem = (props: JudgeSummaryItemProps) => {

/*
    options->
        assign reviewCode
        assign candidates -> opens tabs of candidatesList/reviewCodes
                                for each candidate-> assign reviewCode
                                or upload excel file with usernames+reviewCodes

    candidateReview
        judge
            judge cant view name or username
            add comments textBox

            when saving add row to table JudgeReviews


        admin
            can view all judgeReviews
            assigns final level
*/

  const toast = useToast();
  const queryClient = useQueryClient();

  const [inLineEditMode, setInLineEditMode] = useState(false);
  const [revisionCodeValue, setRevisionCodeValue] = useState("");

  const updateUserMutation = useMutation(({username,
                                            revisionCode}: any) =>
      updateUserRevisionCode(username, revisionCode),
    {
      onSuccess: (data, variables) => {
        if (variables.revisionCode === "") {
          // if (props.user.tags !== undefined && props.user.tags !== null)
           props.user.tags = props.user.tags.filter(tag=>tag.key!=="REVISION_CODE");
        } else {
          const tag = getUserTag(props.user.tags, "REVISION_CODE");
          if (tag !== undefined)
            tag.value = variables.revisionCode;
          else
            props.user.tags.push({ key: "REVISION_CODE", value: variables.revisionCode }) ;
        }

        successToast(toast, "Usuario actualizado");
        return queryClient.invalidateQueries(adminKeys.users());
      },
      onError: () => {
        errorToast(toast, "Error actualizando usuario");
      },
    });

  function handleSaveClick() {

    //if (nameValue === null) setNameValue("");
    //if (props.user.authorities[0] === undefined || props.user.authorities[0] === null) setRoleValue("");

    updateUserMutation.mutate({
      username: props.user.username,
      revisionCode: revisionCodeValue.trim(),
    });
  }

  useEffect(() => {
    if (props?.user ) {
      const tag = getUserTag(props.user.tags, "REVISION_CODE");
      if (tag !== undefined && revisionCodeValue !== tag.value)
        setRevisionCodeValue(tag.value);
    }
  }, [props.user]);

  return (
    <>
      <Tr key={props.user.username}>
        <Td>{props.user.username}</Td>
        <Td>{props.user.name}</Td>
        <Td>{props.user.institution}</Td>
        <Td>{props.user.region}</Td>
        <Td>{props.user.uGroup}</Td>
        <Td>{props.user.email}</Td>
        <Td>{props.user.emailSecond}</Td>
        <Td>
          { inLineEditMode ?
              <Input
               value={revisionCodeValue}
               onChange={(e) => {
                 setRevisionCodeValue(e.target.value);
              }}/>
              :
              <>{revisionCodeValue}</>
          }
        </Td>
        <Td>
            <Button onClick={()=>{
                      if (inLineEditMode) {
                          handleSaveClick();
                      }
                      setInLineEditMode(!inLineEditMode);
                    }}
                    colorScheme={inLineEditMode ? 'green' : 'teal' }
            >
              {inLineEditMode ? 'Guardar' : 'Editar código de revisión'}
            </Button>
        </Td>
      </Tr>
    </>
  );
};

export default JudgeSummaryItem;
